import React from "react";
import "./signin.style.css";
import { NotificationManager } from "react-notifications";
import { IconContext } from "react-icons";
import { BiHide, BiShow } from "react-icons/bi";
import { Backdrop, CircularProgress } from "@mui/material";
import { userSignin, userSigninFailure, userSignOut } from "../../store/auth/auth.actions";
import { selectSigninStatus } from "../../store/auth/auth.selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import validator from "validator";

export class Signin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            isLoading: false,
            obscurePassword: true,
        };
    }

    componentDidMount() {
        this.props.userSignOut();
        if (this.props.signinStatus.isCodeValid === false) {
            this.props.history.replace("/");
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { signinStatus, userSigninFailure } = this.props;
        if (signinStatus.signinSuccess !== null) {
            // console.log(signinStatus);
            if (signinStatus.signinSuccess) {
                // console.log("success");
                NotificationManager.success("Signed In Successfully.", "", 2000);
                this.props.history.push("/verticals");
                userSigninFailure({ signinSuccess: false, loading: false, err: null });
            } else {
                // console.log("failure");
                if (signinStatus.error != null) {
                    NotificationManager.error(signinStatus.error, "", 2000);
                    this.setState({ isLoading: false });
                    userSigninFailure({
                        signinSuccess: false,
                        loading: false,
                        err: null,
                    });
                }
            }
        }
    }

    signIn = (event) => {
        event.preventDefault();
        if (this.state.email === "") {
            NotificationManager.warning("Please Enter Email.", "", 2000);
        } else if (!validator.isEmail(this.state.email)) {
            NotificationManager.warning("Please Enter Valid Email.", "", 2000);
        } else if (this.state.password === "") {
            NotificationManager.warning("Please Enter Password.", "", 2000);
        } else if (this.state.password !== "" && this.state.email !== "") {
            const payload = {
                username: this.state.email,
                password: this.state.password,
                appId: this.props.signinStatus.appId,
            };
            this.setState({ isLoading: true });
            this.props.userSignin(payload);
        }
    };

    render() {
        return (
            <>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={this.state.isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "30%",
                        }}
                    >
                        <form
                            onSubmit={(event) => this.signIn(event)}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: "30%",
                            }}
                        >
                            <p
                                className="title"
                                style={{
                                    fontSize: "35px",
                                    fontWeight: 600,
                                    letterSpacing: 2,
                                    margin: "10px 0",
                                }}
                            >
                                Sign In
                            </p>
                            <div style={{ width: "100%", margin: "10px" }}>
                                <p style={{ margin: 0 }}>Email</p>
                                <input
                                    className="textInput"
                                    type="email"
                                    value={this.state.email}
                                    onChange={(e) => {
                                        this.setState({ email: e.target.value });
                                    }}
                                    placeholder="Email Address"
                                    style={{
                                        height: "50px",
                                        width: "100%",
                                        padding: "0 20px",
                                        border: "#003087 solid 1px",
                                        borderRadius: "5px",
                                        backgroundColor: "#eeeeee",
                                        color: "#3f3f3f",
                                        fontSize: "17px",
                                    }}
                                />
                            </div>
                            <div style={{ width: "100%", margin: "10px" }}>
                                <p style={{ margin: 0 }}>Password</p>
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <input
                                        className="textInput"
                                        type={this.state.obscurePassword ? "password" : "text"}
                                        value={this.state.password}
                                        onChange={(e) => {
                                            this.setState({ password: e.target.value });
                                        }}
                                        placeholder="Password"
                                        style={{
                                            height: "50px",
                                            width: "100%",
                                            padding: "0 50px 0 20px",
                                            border: "#003087 solid 1px",
                                            borderRadius: "5px",
                                            backgroundColor: "#eeeeee",
                                            color: "#3f3f3f",
                                            fontSize: "17px",
                                        }}
                                    />
                                    <IconContext.Provider value={{ color: "#000000", size: "20px" }}>
                                        {this.state.obscurePassword ? (
                                            <BiShow
                                                style={{ position: "absolute", right: "15px" }}
                                                onClick={() => {
                                                    this.setState({
                                                        obscurePassword: !this.state.obscurePassword,
                                                    });
                                                }}
                                            />
                                        ) : (
                                            <BiHide
                                                style={{ position: "absolute", right: "15px" }}
                                                onClick={() => {
                                                    this.setState({
                                                        obscurePassword: !this.state.obscurePassword,
                                                    });
                                                }}
                                            />
                                        )}
                                    </IconContext.Provider>
                                </div>
                            </div>
                            {/* <div style={{ width: "100%", color: "#003087", textAlign: "end", margin: "10px" }}>
                            <p
                                onClick={() => {
                                    // this.props.updateRoute("forgotPassword");
                                }}
                                style={{ textAlign: "end", fontSize: "17px", cursor: "pointer" }}
                            >
                                Forgot Password?
                            </p>
                        </div> */}
                            <button
                                type="submit"
                                onClick={(event) => {
                                    this.signIn(event);
                                    // this.signInUsingSubscription();
                                }}
                                style={{
                                    width: "fit-content",
                                    padding: "0 30px",
                                    height: "60px",
                                    margin: "50px 0",
                                    borderRadius: "30px",
                                    textAlign: "center",
                                    color: "#ffffff",
                                    backgroundColor: "#003087",
                                    border: "0",
                                    fontSize: "18px",
                                    letterSpacing: "0.5px",
                                    wordSpacing: "2px",
                                }}
                            >
                                Sign In
                            </button>
                            {/* <p
                            style={{
                                fontSize: "17px",
                                wordSpacing: "2px",
                                margin: "10px 0",
                            }}
                        >
                            Don`t have an account?{" "}
                            <span
                                onClick={() => {
                                    this.props.history.replace("/signup");
                                }}
                                style={{ color: "#003087", cursor: "pointer" }}
                            >
                                Register Here
                            </span>
                        </p> */}
                        </form>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signinStatus: selectSigninStatus(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(
        {
            userSignOut,
            userSignin,
            userSigninFailure,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
